// Minijuego de "restauración": el visitante gira la escultura hasta cubrir
// las 4 caras (frente/lateral/espalda/lateral) y se acerca al menos una vez
// para "enfocar un detalle". Se apoya en el evento camera-change que ya
// expone VisorRA (prop onCameraOrbitChange), sin agregar dependencias nuevas.

export const RESTORATION_ZONE_LABELS = ['Frente', 'Lateral derecho', 'Espalda', 'Lateral izquierdo'];
export const RESTORATION_ZOOM_LABEL = 'Detalle de cerca';
export const RESTORATION_TOTAL_STEPS = RESTORATION_ZONE_LABELS.length + 1;
export const RESTORATION_ZOOM_RATIO = 0.7; // hay que acercarse a <70% del radio inicial

const normalizeDeg = (deg) => ((deg % 360) + 360) % 360;

export function zoneIndexForTheta(thetaRad) {
  if (!Number.isFinite(thetaRad)) return null;
  const deg = normalizeDeg((thetaRad * 180) / Math.PI + 45);
  return Math.floor(deg / 90) % 4;
}
